// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__XCV7F","name":"Nav_name__2djPm","about":"Nav_about__sUN43","fav":"Nav_fav__5I1LJ","img":"Nav_img__tDcjb","random":"Nav_random__dvL3I"};